import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registers sw.js — required for offline caching AND for push
// notifications to work at all (navigator.serviceWorker.ready never
// resolves without this, which was silently hanging the entire "Order
// Notifications" flow with no error at all). Runs after the page has
// finished loading, so it doesn't compete with the app's own initial
// render for resources.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error) => {
      console.error("Service worker registration failed:", error);
    });
  });
}
